/* eslint-disable no-unused-vars, jsx-a11y/alt-text, react-hooks/exhaustive-deps */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
    const [activeTour, setActiveTour] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [tourData, setTourData] = useState([]);

    const startTour = (name, steps) => {
        const hasSeen = localStorage.getItem(`tour_${name}`);
        if (!hasSeen) {
            setTourData(steps);
            setActiveTour(name);
            setCurrentStep(0);
        }
    };

    const nextStep = () => {
        if (currentStep < tourData.length - 1) {
            setCurrentStep(currentStep + 1);
        } else {
            finishTour();
        }
    };

    const finishTour = () => {
        localStorage.setItem(`tour_${activeTour}`, 'true');
        setActiveTour(null);
    };

    return (
        <TourContext.Provider value={{ activeTour, currentStep, tourData, startTour, nextStep, finishTour }}>
            {children}
            <AnimatePresence>
                {activeTour && tourData[currentStep] && (
                    <TourOverlay step={tourData[currentStep]} onNext={nextStep} onSkip={finishTour} isLast={currentStep === tourData.length - 1} />
                )}
            </AnimatePresence>
        </TourContext.Provider>
    );
};

const TourOverlay = ({ step, onNext, onSkip, isLast }) => {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none p-6">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm pointer-events-auto"
            />
            <motion.div
                initial={{ scale: 0.9, opacity: 0, y: 20 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.9, opacity: 0, y: 20 }}
                className="relative bg-white dark:bg-slate-800 rounded-3xl shadow-2xl p-8 max-w-md w-full pointer-events-auto border border-white/20 dark:border-slate-700 font-cairo"
            >
                <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-2xl flex items-center justify-center text-2xl">
                        {step.icon || '🚀'}
                    </div>
                    <div>
                        <h4 className="font-black text-xl text-slate-800 dark:text-white">{step.title}</h4>
                        <p className="text-sm text-slate-500 dark:text-slate-400">خطوة تعليمية مفيدة</p>
                    </div>
                </div>
                <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed">
                    {step.content}
                </p>
                <div className="flex items-center justify-between gap-4">
                    <button onClick={onSkip} className="text-slate-400 dark:text-slate-500 hover:text-slate-600 font-bold text-sm">
                        تخطي الجولة
                    </button>
                    <button
                        onClick={onNext}
                        className="px-6 py-3 bg-indigo-600 text-white rounded-xl font-black shadow-lg shadow-indigo-200 dark:shadow-none hover:bg-indigo-700 transition-all flex items-center gap-2"
                    >
                        <span>{isLast ? 'ابدأ الاستخدام' : 'التالي'}</span>
                        <span className="text-lg">←</span>
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export const useTour = () => useContext(TourContext);
